import { fetchContent, postContent } from "../../lib/fetchData";
import { IContactFormContext } from "./Context";
import {
  ContactFormResult,
  ContactRequest,
  OrderLookupRequest,
  OrderLookupResult,
} from "./types";

export const ContactFormApiRepo: IContactFormContext = {
  LookupOrder: (orderNumber: number, email: string, ticketId?: number) => {
    const url = "/api/contactform/lookuporder";

    return postContent<OrderLookupRequest, OrderLookupResult>(url, {
      OrderNumber: orderNumber,
      Email: email,
      TicketId: ticketId || 0,
    });
  },
  GetTicketTypes: () => {
    return fetchContent("/api/contactform/gettickettypes");
  },
  SaveMessage: function (request: ContactRequest): Promise<ContactFormResult> {
    const url = "/api/contactform/savemessage";
    return postContent<ContactRequest, ContactFormResult>(url, request);
  },
};
